import React from "react";

const ConfirmNavigationModal = ({ isOpen, onCancel, onConfirm, message }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 rounded-lg bg-black bg-opacity-50 flex items-center justify-center z-40">
      <div className="bg-tier-primary dark:bg-tier-primary-dark dark:border-gray-600 border p-8 rounded-lg shadow-md max-w-md w-full">
        <p className="mb-4">{message}</p>
        <div className="flex justify-end gap-4">
          <button onClick={onCancel} className="btn-action-white">
            Stay
          </button>
          <button onClick={onConfirm} className="btn-action">
            Leave
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmNavigationModal;
